// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__2jDxI","alert":"SettungsInbox_alert__19WRL"};